/**
 * UniversityTeaser — Landlord University promo split with 2-col grid of
 * topic badges. Free, evergreen, no email gate. Extracted from Landing.jsx.
 */
import { Link } from "react-router-dom";
import { ArrowRight, BarChart3, Calculator, GraduationCap, Hammer, Lightbulb, TrendingUp } from "lucide-react";

const TOPICS = [
  { icon: GraduationCap, t: "Getting started",         s: "4 lessons" },
  { icon: BarChart3,     t: "Day-to-day management",    s: "5 lessons" },
  { icon: Hammer,        t: "DIY maintenance",          s: "5 lessons" },
  { icon: Calculator,    t: "Tax & compliance",         s: "5 lessons" },
  { icon: TrendingUp,    t: "Growing your portfolio",   s: "5 lessons" },
  { icon: Lightbulb,     t: "More coming soon",         s: "Updated monthly" },
];

export default function UniversityTeaser() {
  return (
    <section id="university" className="py-16 md:py-24 bg-gradient-to-br from-emerald-50 via-white to-sky-50 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-100 border border-emerald-200 text-[11px] uppercase tracking-[0.18em] font-bold text-emerald-700">
            <GraduationCap className="w-3 h-3"/> Landlord University · Free
          </div>
          <h2 className="font-display mt-4 text-2xl sm:text-3xl md:text-4xl font-bold tracking-tighter text-slate-900 leading-[1.05]">
            Become a better Canadian landlord — one lesson at a time.
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-700 leading-relaxed max-w-xl">
            25+ curated lessons across 5 topic areas: getting started, day-to-day management, DIY repairs, CRA tax, and growing your portfolio. Free, evergreen, no email gate.
          </p>
          <Link to="/university" data-testid="university-cta"
            className="mt-7 inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold shadow-lg shadow-emerald-500/20 transition-colors">
            Browse the university <ArrowRight className="w-4 h-4"/>
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {TOPICS.map((b, i) => {
            const Icon = b.icon;
            return (
              <div key={i} className="bg-white rounded-2xl border border-slate-200 p-5 shadow-sm" data-testid={`university-card-${i}`}>
                <Icon className="w-5 h-5 text-emerald-600"/>
                <div className="font-display text-sm font-bold text-slate-950 mt-3 leading-snug">{b.t}</div>
                <div className="text-xs text-slate-500 mt-1">{b.s}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
